export const IS_PROD = process.env.NODE_ENV === 'production';
const HOST = IS_PROD ? 'widget.ravely.io' : window.location.host;
const ORIGIN = IS_PROD ? `https://${HOST}` : `http://${HOST}`;
const API_PATH = ORIGIN + '/api/public';
export var EmbedType;
(function (EmbedType) {
    EmbedType["FloatingWidget"] = "floating-widget";
    EmbedType["WallOfLove"] = "wall-of-love";
    EmbedType["Marquee"] = "marquee";
})(EmbedType || (EmbedType = {}));
export const EMBED_TYPE_ARR = Object.values(EmbedType);
export const uri = {
    telemetryPost: API_PATH + '/telemetry-post',
    bizReviews: API_PATH + '/biz-reviews',
    floatingWidgetSettings: API_PATH + '/floating/settings',
    // External API
    telemetry: HOST + '/api/telemetry',
};
export const AMPLITUDE_KEY = process.env.AMPLITUDE_KEY;
// Origins on which we will show all reviews regardless of plan
// also affects other things e.g. suspend telemetry
const INTERNAL_ORIGIN_LIST = ['http://localhost:5051', 'https://ravely.io'];
const currentOrigin = (typeof window === 'object' && window.location.origin) || '';
export const IS_INTERNAL_ORIGIN = INTERNAL_ORIGIN_LIST.includes(currentOrigin);
